import React, { memo, SVGProps } from 'react'

export const Lightbulb = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.1917 14.2474C18.3312 11.7773 17.5603 8.82433 15.361 7.22689C13.3507 5.76481 10.6502 5.76481 8.63999 7.22689C6.43967 8.82433 5.66879 11.7773 6.80831 14.2474L8.46047 17.8291L8.96159 19.4813C9.28511 20.5536 10.2557 21.2746 11.377 21.2746H12.624C13.7453 21.2746 14.7158 20.5536 15.0394 19.4823L15.5405 17.8291L17.1917 14.2474ZM9.48575 8.39041C10.9891 7.29697 13.0099 7.29697 14.5133 8.39041C16.1587 9.58657 16.7347 11.7955 15.8842 13.6435L14.4029 16.8547H9.59519L8.11391 13.6435C7.26239 11.7955 7.84031 9.58657 9.48575 8.39041ZM13.6598 19.0647C13.5206 19.5245 13.104 19.8346 12.623 19.8346H11.376C10.895 19.8346 10.4774 19.5255 10.3392 19.0637L10.1059 18.2938H13.8931L13.6598 19.0647Z"
      fill="currentColor"
    />
    <path
      d="M4.26047 11.2493H3.46847C3.07103 11.2493 2.74847 11.5719 2.74847 11.9693C2.74847 12.3667 3.07103 12.6893 3.46847 12.6893H4.26047C4.65791 12.6893 4.98047 12.3667 4.98047 11.9693C4.98047 11.5719 4.65791 11.2493 4.26047 11.2493Z"
      fill="currentColor"
    />
    <path
      d="M20.5325 11.2493H19.7405C19.343 11.2493 19.0205 11.5719 19.0205 11.9693C19.0205 12.3667 19.343 12.6893 19.7405 12.6893H20.5325C20.9299 12.6893 21.2525 12.3667 21.2525 11.9693C21.2525 11.5719 20.9299 11.2493 20.5325 11.2493Z"
      fill="currentColor"
    />
    <path
      d="M12 4.94881C12.3974 4.94881 12.72 4.62625 12.72 4.22881V3.43777C12.72 3.04033 12.3974 2.71777 12 2.71777C11.6026 2.71777 11.28 3.04033 11.28 3.43777V4.22881C11.28 4.62625 11.6026 4.94881 12 4.94881Z"
      fill="currentColor"
    />
    <path
      d="M6.01823 7.00513C6.15839 7.14529 6.34271 7.21633 6.52703 7.21633C6.71135 7.21633 6.89567 7.14625 7.03583 7.00513C7.31711 6.72385 7.31711 6.26785 7.03583 5.98657L6.47615 5.42689C6.19487 5.14561 5.73887 5.14561 5.45759 5.42689C5.17631 5.70817 5.17631 6.16417 5.45759 6.44545L6.01823 7.00513Z"
      fill="currentColor"
    />
    <path
      d="M17.9818 16.9335C17.7005 16.6522 17.2445 16.6522 16.9632 16.9335C16.6819 17.2147 16.6819 17.6707 16.9632 17.952L17.5229 18.5117C17.663 18.6519 17.8474 18.7229 18.0317 18.7229C18.216 18.7229 18.4003 18.6528 18.5405 18.5117C18.8218 18.2304 18.8218 17.7744 18.5405 17.4931L17.9818 16.9335Z"
      fill="currentColor"
    />
    <path
      d="M17.5238 5.42689L16.9642 5.98657C16.6829 6.26785 16.6829 6.72385 16.9642 7.00513C17.1043 7.14529 17.2886 7.21633 17.473 7.21633C17.6573 7.21633 17.8416 7.14625 17.9818 7.00513L18.5414 6.44545C18.8227 6.16417 18.8227 5.70817 18.5414 5.42689C18.2602 5.14561 17.8051 5.14561 17.5238 5.42689Z"
      fill="currentColor"
    />
    <path
      d="M6.01823 16.9335L5.45855 17.4931C5.17727 17.7744 5.17727 18.2304 5.45855 18.5117C5.59871 18.6519 5.78303 18.7229 5.96735 18.7229C6.15167 18.7229 6.33599 18.6528 6.47615 18.5117L7.03583 17.952C7.31711 17.6707 7.31711 17.2147 7.03583 16.9335C6.75455 16.6522 6.29951 16.6522 6.01823 16.9335Z"
      fill="currentColor"
    />
  </svg>
))
